import React, { useContext } from 'react';
import { Wrapper } from './styled';
import CustomReactTable from 'Common/Components/Contextualization/CustomReactTable/styled';
import { setCredentialSelected, setOrderByCredentials, showContextMenu, unselectAllCredentials } from 'store/Credentials/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCredentialsList, selectCredentialsSelected, selectIsFetching } from 'store/Credentials/selectors';
import { ThemeContext } from 'Context';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

const Table = ({ columns, isVulnDetail }) => {
  const dispatch = useDispatch();
  const showContextMenuAction = (value, xPos, yPos) => dispatch(showContextMenu(value, xPos, yPos));
  const data = useSelector(selectCredentialsList);
  const { themeStyles } = useContext(ThemeContext);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const isFetching = useSelector(selectIsFetching);
  const unselectAll = () => dispatch(unselectAllCredentials());
  const selectCredential = (credential) => dispatch(setCredentialSelected(credential));
  const mockData = [...Array(15).keys()];

  const getTrProps = (rowInfo, showContextMenuAction, isFetching, unselectAll, selectCredential) => {
    const rowId = get(rowInfo, 'original.id', '');
    const isSelected = credentialsSelected.some((e) => e.id === rowId);
    if (rowInfo && rowInfo.row) {
      return {
        onContextMenu: (e) => {
          e.preventDefault();
          showContextMenuAction(true, e.pageX, e.pageY);
          if (!isSelected && !isFetching) {
            unselectAll();
            selectCredential(rowInfo.original);
          }
        },
        style: {
          background: isSelected ? `${themeStyles?.backgrounds?.selectedTableItem}` : ''
        }
      };
    }
    return {};
  };

  const fetchData = (tableState) => !isFetching && dispatch(setOrderByCredentials(tableState.sorted, isVulnDetail));

  return (
    <Wrapper>
      <CustomReactTable
        data={ !isFetching ? data : mockData }
        columns={ columns }
        minRows={ 0 }
        expanded
        manual
        onFetchData={ fetchData }
        showPagination={ false }
        getTrProps={ (_, rowInfo) => getTrProps(rowInfo, showContextMenuAction, isFetching, unselectAll, selectCredential) }
        style={ isVulnDetail && isEmpty(data) ? { height: '95px' } : null }
      />
    </Wrapper>
  );
};

export default Table;
